export const formatDateWithFields = (
  year: string,
  month: string,
  day: string,
) => {
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.toISOString().split('T')[0];
};
